import React, { useState } from 'react';

const ChatGPTChat = () => {
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState('');

  const sendMessage = async () => {
    if (inputText.trim() === '') return;

    // Add user message to chat window
    const userMessage = { text: inputText, sender: 'user' };
    setMessages((prevMessages) => [...prevMessages, userMessage]);

    try {
      // Fetch response from ChatGPT API (Chat API)
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer sk-proj-xGs20eUbJWgkIBGHUDCGT3BlbkFJK9KakRHkLLf9Xu3YJasZ`, // Add your API key here
        },
        body: JSON.stringify({
          model: 'gpt-4o', // Or 'gpt-3.5-turbo' for GPT-3.5
          messages: [{ role: 'user', content: inputText }],
        }),
      });

      const data = await response.json();
      const gptMessage = { text: data.choices[0].message.content.trim(), sender: 'gpt' };

      // Add GPT response to chat window
      setMessages((prevMessages) => [...prevMessages, gptMessage]);

    } catch (error) {
      console.error('Error fetching GPT response:', error);
    }

    // Clear the input field after sending the message
    setInputText('');
  };

  return (
    <div style={styles.chatContainer}>
      <div style={styles.chatWindow}>
        {messages.map((msg, index) => (
          <div
            key={index}
            style={msg.sender === 'user' ? styles.userMessage : styles.gptMessage}
          >
            {msg.text}
          </div>
        ))}
      </div>
      <div style={styles.inputContainer}>
        <input
          type="text"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          style={styles.input}
          placeholder="Type your message..."
        />
        <button onClick={sendMessage} style={styles.button}>Send</button>
      </div>
    </div>
  );
};

const styles = {
  chatContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100vw',
  },
  chatWindow: {
    flex: 1,
    padding: '10px',
    overflowY: 'auto',
    backgroundColor: '#f1f1f1',
  },
  userMessage: {
    textAlign: 'right',
    padding: '10px',
    backgroundColor: '#007bff',
    color: 'white',
    borderRadius: '10px',
    margin: '5px 0',
  },
  gptMessage: {
    textAlign: 'left',
    padding: '10px',
    backgroundColor: '#e1e1e1',
    borderRadius: '10px',
    margin: '5px 0',
  },
  inputContainer: {
    display: 'flex',
    padding: '10px',
    borderTop: '1px solid #ccc',
    backgroundColor: '#fff',
  },
  input: {
    flex: 1,
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  button: {
    marginLeft: '10px',
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default ChatGPTChat;
